export default "<process-heading [departmentId]='deptId' [processId]='processId'></process-heading>"